var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "htmlclass",
          rawName: "v-htmlclass",
          value: _vm.customHtmlClasses,
          expression: "customHtmlClasses"
        }
      ],
      staticClass: "products",
      style: "--no-image-text:  '" + _vm.$t("shoplist.noImage") + "';"
    },
    [
      _vm.menuMode
        ? _c("ShopMenuHeader", {
            staticClass:
              "menu-header--mobile insicht insicht--fade-up insicht--fast",
            attrs: {
              title: _vm.menuLocationName,
              subtitle: _vm.$t("shoplist.menu.title")
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "products__wrapper" }, [
        _c(
          "div",
          {
            ref: "categories",
            staticClass:
              "products__categories insicht insicht--fade-up insicht--fast"
          },
          [
            _c("ListScrollPane", {
              staticClass: "products__categories-wrapper",
              class: {
                "products__categories-wrapper--main": _vm.showSubCategories
              },
              attrs: { "to-watch": _vm.categories },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var canScroll = ref.canScroll
                    var scrolledTop = ref.scrolledTop
                    var scrolledBottom = ref.scrolledBottom
                    var scrolled = ref.scrolled
                    return [
                      _c("ShoplistFilter", {
                        attrs: {
                          filters: _vm.filters,
                          filtersActive: _vm.filtersActive
                        },
                        on: { apply: _vm.onFilterApply }
                      }),
                      _vm._v(" "),
                      [
                        _c("div", {
                          staticClass:
                            "products__categories-group-overlap products__categories-group-overlap--before",
                          class: {
                            "products__categories-group-overlap--visible":
                              canScroll && !scrolledTop,
                            "products__categories-group-overlap--scrolled": scrolled
                          },
                          attrs: { "data-scrollcontainer-up": "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "categoryGroup",
                            staticClass: "products__categories-group",
                            attrs: { "data-scrollcontainer": "" }
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "products__categories-list" },
                              [
                                _vm.showPersonalStartpage
                                  ? _c("ShoplistCategory", {
                                      ref: "categoryLink",
                                      attrs: {
                                        category: {
                                          svgIconKey: "category-favorites",
                                          name: _vm.$t(
                                            "shoplist.favorites.title"
                                          )
                                        },
                                        active:
                                          _vm.activeCategory ==
                                          _vm.favoriteCode,
                                        "data-scrollcontainer-item": ""
                                      },
                                      on: { click: _vm.onFavoriteProducts }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.categories, function(category) {
                                  return _c("ShoplistCategory", {
                                    key: category.code,
                                    ref: "categoryLink",
                                    refInFor: true,
                                    attrs: {
                                      category: category,
                                      active:
                                        _vm.currentScrollCategory &&
                                        !_vm.showSubCategories
                                          ? _vm.currentScrollCategory ==
                                            category.code
                                          : _vm.activeCategory == category.code,
                                      "data-scrollcontainer-item": ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onChangeCategory(category)
                                      }
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "products__categories-group-overlap products__categories-group-overlap--after",
                          class: {
                            "products__categories-group-overlap--visible":
                              canScroll && !scrolledBottom,
                            "products__categories-group-overlap--scrolled": scrolled
                          },
                          attrs: { "data-scrollcontainer-down": "" }
                        })
                      ]
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _vm.showSubCategories
              ? _c("ListScrollPane", {
                  staticClass:
                    "products__categories-wrapper products__categories-wrapper--subcategories",
                  attrs: { "to-watch": _vm.currentSubCategories },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var canScroll = ref.canScroll
                          var scrolledTop = ref.scrolledTop
                          var scrolledBottom = ref.scrolledBottom
                          var scrolled = ref.scrolled
                          return [
                            [
                              _c("div", {
                                staticClass:
                                  "products__categories-group-overlap products__categories-group-overlap--before products__categories-group-overlap--subcategory",
                                class: {
                                  "products__categories-group-overlap--visible":
                                    canScroll && !scrolledTop,
                                  "products__categories-group-overlap--scrolled": scrolled
                                },
                                attrs: { "data-scrollcontainer-up": "" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "subCategoryGroup",
                                  staticClass: "products__categories-group",
                                  attrs: { "data-scrollcontainer": "" }
                                },
                                [
                                  _c(
                                    "ul",
                                    {
                                      staticClass: "products__categories-list"
                                    },
                                    _vm._l(_vm.currentSubCategories, function(
                                      category
                                    ) {
                                      return _c("ShoplistCategory", {
                                        key: category.code,
                                        ref: "categoryLink",
                                        refInFor: true,
                                        attrs: {
                                          category: category,
                                          active: _vm.currentScrollCategory
                                            ? _vm.currentScrollCategory ==
                                              category.code
                                            : _vm.activeSubCategory ==
                                              category.code,
                                          modifier: "subcategory",
                                          "data-scrollcontainer-item": ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onChangeSubCategory(
                                              category
                                            )
                                          }
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "products__categories-group-overlap products__categories-group-overlap--after products__categories-group-overlap--subcategory",
                                class: {
                                  "products__categories-group-overlap--visible":
                                    canScroll && !scrolledBottom,
                                  "products__categories-group-overlap--scrolled": scrolled
                                },
                                attrs: { "data-scrollcontainer-down": "" }
                              })
                            ]
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2032965171
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "products__inner insicht insicht--fade-in insicht--fast",
            class: {
              "products__inner--public": !_vm.hasBasket && !_vm.menuMode,
              "products__inner--menu": _vm.menuMode
            }
          },
          [
            _vm.hasBasket && !_vm.menuMode ? _c("ShopHeader") : _vm._e(),
            _vm._v(" "),
            _vm.menuMode
              ? _c("ShopMenuHeader", {
                  attrs: {
                    title: _vm.menuLocationName,
                    subtitle: _vm.$t("shoplist.menu.title")
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasFeature("FEATURE_GROUP_ORDERS") &&
            _vm.cartIsGroupOrder &&
            _vm.groupOrderIsOwner
              ? _c("div", { staticClass: "group-order-share" }, [
                  _c("div", {
                    staticClass: "group-order-share__text",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("grouporder.share.text"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "group-order-share__link" }, [
                    _c("div", {
                      staticClass: "group-order-share__link-text",
                      domProps: { innerHTML: _vm._s(_vm.groupOrderJoinUrl) }
                    }),
                    _vm._v(" "),
                    _vm.copyGroupOrderUrlCopied
                      ? _c("div", {
                          staticClass: "group-order-share__link-success",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("grouporder.share.copied"))
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "group-order-share__link-button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onCopyGroupOrderUrl(
                              _vm.groupOrderJoinUrl
                            )
                          }
                        }
                      },
                      [
                        _c("SVGDuplicate", {
                          staticClass: "group-order-share__link-button-icon"
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "group-order-share__link-button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onGroupOrderQR.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("SVGQrCode", {
                          staticClass: "group-order-share__link-button-icon"
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasBasket &&
            _vm.isLoggedIn &&
            _vm.lastOrdersFiltered.length &&
            !_vm.showFavorites &&
            !_vm.menuMode
              ? _c(
                  "div",
                  { staticClass: "last-orders-teaser" },
                  [
                    _c("SVGBag", { staticClass: "last-orders-teaser__icon" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "last-orders-teaser__content" },
                      [
                        _c("div", {
                          staticClass: "last-orders-teaser__text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.lastOrders.teaserText")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("Button", {
                          staticClass: "last-orders-teaser__button",
                          attrs: {
                            level: "tertiary",
                            text: _vm.$t("shoplist.lastOrders.teaserButton"),
                            type: "button",
                            arrow: ""
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.onFavoriteProducts.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasBasket &&
            _vm.isLoggedIn &&
            _vm.showFavorites &&
            !_vm.menuMode
              ? _c("LastOrders", {
                  staticClass: "products__last-orders",
                  attrs: { orders: _vm.lastOrdersFiltered },
                  on: { click: _vm.onLastOrderClick }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoggedIn &&
            _vm.favoriteProducts.length &&
            _vm.showFavorites &&
            !_vm.menuMode
              ? _c("h2", {
                  staticClass: "products__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.favorites.title"))
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("Loader", {
              staticClass: "products__loader",
              attrs: { show: _vm.productsLoading && !_vm.loading }
            }),
            _vm._v(" "),
            _vm.productsEnhanced && !_vm.productsLoading
              ? _c(
                  "div",
                  {
                    staticClass: "products__grid",
                    class: {
                      "products__grid--public": !_vm.hasBasket && !_vm.menuMode,
                      "products__grid--menu": _vm.menuMode
                    }
                  },
                  [
                    !_vm.productsEnhanced.length
                      ? _c("div", {
                          staticClass: "products__grid-empty",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("shoplist.noProducts"))
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.showFavorites && _vm.currentCategoryIsOverview
                      ? _vm._l(_vm.productsEnhancedCategories, function(
                          category
                        ) {
                          return _c(
                            "div",
                            {
                              key: category.category.code,
                              staticClass: "products__category products__grid",
                              class: {
                                "products__grid--public":
                                  !_vm.hasBasket && !_vm.menuMode,
                                "products__grid--menu": _vm.menuMode
                              }
                            },
                            [
                              _c("ShoplistCategoryHeader", {
                                ref: "categoryHeader",
                                refInFor: true,
                                attrs: { category: category.category }
                              }),
                              _vm._v(" "),
                              _vm._l(category.products, function(
                                product,
                                index
                              ) {
                                return _c("ShoplistProduct", {
                                  key: category.category.code + product.code,
                                  attrs: {
                                    product: product,
                                    locked:
                                      _vm.lockedProducts[
                                        category.category.code +
                                          "-" +
                                          product.code
                                      ],
                                    disabled:
                                      _vm.cartIsGroupOrderLocked ||
                                      _vm.groupOrderParticipantReady
                                  },
                                  on: {
                                    addToCart: function($event) {
                                      return _vm.onAddToCart(
                                        $event,
                                        category.category.code
                                      )
                                    },
                                    config: _vm.onConfig,
                                    click: function($event) {
                                      return _vm.onClickProduct(
                                        $event,
                                        category.category.code
                                      )
                                    },
                                    orderbox: _vm.onOrderboxOpen
                                  }
                                })
                              }),
                              _vm._v(" "),
                              category.children && category.children.length
                                ? _vm._l(category.children, function(child, i) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "products__category-child products__grid"
                                      },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "products__category-child-header"
                                          },
                                          [
                                            _vm.iconComponent(
                                              child.category.svgIconKey
                                            )
                                              ? _c(
                                                  _vm.iconComponent(
                                                    child.category.svgIconKey
                                                  ),
                                                  {
                                                    tag: "component",
                                                    staticClass:
                                                      "products__category-child-header-icon"
                                                  }
                                                )
                                              : _c("SVGInfo", {
                                                  staticClass:
                                                    "products__category-child-header-icon"
                                                }),
                                            _vm._v(" "),
                                            _c("h2", {
                                              staticClass:
                                                "products__category-child-header-title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  child.category.name
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(child.products, function(
                                          product,
                                          index
                                        ) {
                                          return _c("ShoplistProduct", {
                                            key:
                                              child.category.code +
                                              product.code,
                                            attrs: {
                                              product: product,
                                              locked:
                                                _vm.lockedProducts[
                                                  child.category.code +
                                                    "-" +
                                                    product.code
                                                ],
                                              disabled:
                                                _vm.cartIsGroupOrderLocked ||
                                                _vm.groupOrderParticipantReady
                                            },
                                            on: {
                                              addToCart: function($event) {
                                                return _vm.onAddToCart(
                                                  $event,
                                                  child.category.code
                                                )
                                              },
                                              config: _vm.onConfig,
                                              click: function($event) {
                                                return _vm.onClickProduct(
                                                  $event,
                                                  child.category.code
                                                )
                                              },
                                              orderbox: _vm.onOrderboxOpen
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        })
                      : _vm._l(_vm.productsEnhancedLimited, function(
                          product,
                          index
                        ) {
                          return _c("ShoplistProduct", {
                            key: product.code,
                            attrs: {
                              product: product,
                              locked: _vm.lockedProducts[product.code],
                              disabled:
                                _vm.cartIsGroupOrderLocked ||
                                _vm.groupOrderParticipantReady
                            },
                            on: {
                              addToCart: _vm.onAddToCart,
                              config: _vm.onConfig,
                              click: _vm.onClickProduct,
                              orderbox: _vm.onOrderboxOpen
                            }
                          })
                        })
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasBasket && !_vm.menuMode
          ? _c(
              "div",
              { staticClass: "products__cart-placeholder" },
              [
                _c("OverlaySidebarCart", {
                  ref: "sidebarcart",
                  staticClass: "insicht insicht--fade-up insicht--fast",
                  attrs: {
                    "is-inline": "",
                    "locked-products": _vm.lockedProducts
                  },
                  on: { addToCart: _vm.onAddToCart, config: _vm.onConfig }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.menuMode ? _c("MobileStickyCart") : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modal",
          attrs: { "overlay-type": "product-detail" },
          on: { close: _vm.onModalProductClose }
        },
        [
          _vm.modalProductCode
            ? _c("OverlayProduct", {
                attrs: {
                  code: _vm.modalProductCode,
                  "product-data": _vm.modalProduct,
                  locked:
                    _vm.lockedProducts[
                      _vm.modalProductCategory
                        ? _vm.modalProductCategory + "-" + _vm.modalProductCode
                        : _vm.modalProductCode
                    ],
                  disabled:
                    _vm.cartIsGroupOrderLocked ||
                    _vm.groupOrderParticipantReady,
                  "is-shop": ""
                },
                on: {
                  addToCart: function($event) {
                    return _vm.onAddToCart($event, _vm.modalProductCategory)
                  },
                  config: _vm.onConfig,
                  click: _vm.onClickProduct,
                  orderbox: _vm.onOrderboxOpen
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_GROUP_ORDERS") && _vm.cartIsGroupOrder
        ? _c(
            "Modal",
            {
              ref: "groupOrderQR",
              attrs: { "overlay-type": "group-order-qr", narrow: "" }
            },
            [
              _c(
                "div",
                { staticClass: "overlay-dialog" },
                [
                  _c("h2", {
                    staticClass: "overlay-dialog__title",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("grouporder.share.qrTitle"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "overlay-dialog__text",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("grouporder.share.qrText"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "group-order-share" }, [
                    _c("div", { staticClass: "group-order-share__link" }, [
                      _c("div", {
                        staticClass: "group-order-share__link-text",
                        domProps: { innerHTML: _vm._s(_vm.groupOrderJoinUrl) }
                      }),
                      _vm._v(" "),
                      _vm.copyGroupOrderUrlCopied
                        ? _c("div", {
                            staticClass: "group-order-share__link-success",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("grouporder.share.copied")
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "group-order-share__link-button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.onCopyGroupOrderUrl(
                                _vm.groupOrderJoinUrl
                              )
                            }
                          }
                        },
                        [
                          _c("SVGDuplicate", {
                            staticClass: "group-order-share__link-button-icon"
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("QRCode", { attrs: { content: _vm.groupOrderJoinUrl } })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("OverlayError"),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_CHILDPRODUCTS") && _vm.hasBasket && !_vm.menuMode
        ? _c("OverlayChildProducts", {
            ref: "childproductsOverlay",
            on: { edit: _vm.onChildProductsEdit, add: _vm.onChildProductsAdd }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }